import {
    AhaMomentImage,
    type GoalSummaryCardWidgetProps,
} from '@fruitful/types';
import React from 'react';
import { Image, type ImageSourcePropType } from 'react-native';
import {
    BodyMediumRegular,
    BodySmallRegular,
    FrostedSurface,
    H6Emphasized,
    H6Regular,
    isWeb,
    XStack,
    YStack,
} from 'smoothie';

import DiscoverBwImage from '../../assets/images/discover-bw.png';
import GoalBadgeIconSvg from '../../assets/images/goal-badge-icon.svg';
import InvestingImage from '../../assets/images/investing.png';
import ManagementImage from '../../assets/images/management.png';
import RoadmapImage from '../../assets/images/roadmap.png';
import SecureSavingsImage from '../../assets/images/secure-savings.png';

const GOAL_CARD_ILLUSTRATION_SIZE = 120;
const GOAL_CARD_BADGE_ICON_SIZE = 16;

export const GOAL_CARD_IMAGES: Record<AhaMomentImage, ImageSourcePropType> = {
    [AhaMomentImage.Discover]: DiscoverBwImage,
    [AhaMomentImage.DiscoverBw]: DiscoverBwImage,
    [AhaMomentImage.Investing]: InvestingImage,
    [AhaMomentImage.Management]: ManagementImage,
    [AhaMomentImage.Roadmap]: RoadmapImage,
    [AhaMomentImage.SecureSavings]: SecureSavingsImage,
};

const goalCardIllustrationStyle = {
    width: GOAL_CARD_ILLUSTRATION_SIZE,
    height: GOAL_CARD_ILLUSTRATION_SIZE,
    ...(isWeb ? { filter: 'grayscale(100%)' } : {}),
} as const;

export const GoalSummaryCardWidget = ({
    eyebrow = 'Your Fruitful goal',
    title,
    metric,
    image = AhaMomentImage.Discover,
}: GoalSummaryCardWidgetProps) => {
    const illustrationSource = GOAL_CARD_IMAGES[image] ?? DiscoverBwImage;

    return (
        <FrostedSurface alignSelf="center" width="100%" maxWidth={345}>
            <YStack width="100%">
                <YStack
                    width="100%"
                    padding={16}
                    backgroundColor="rgba(255, 255, 255, 0.5)"
                    borderBottomWidth={1}
                    borderBottomColor="$white"
                >
                    <XStack gap={8} alignItems="center">
                        <GoalBadgeIconSvg
                            width={GOAL_CARD_BADGE_ICON_SIZE}
                            height={GOAL_CARD_BADGE_ICON_SIZE}
                        />
                        <BodyMediumRegular color="$green1100">
                            {eyebrow}
                        </BodyMediumRegular>
                    </XStack>
                </YStack>
                <YStack width="100%" padding={16}>
                    <XStack gap={16} alignItems="center" width="100%">
                        <Image
                            source={illustrationSource}
                            resizeMode="contain"
                            style={goalCardIllustrationStyle}
                        />
                        <YStack flex={1} gap={16} justifyContent="center">
                            <H6Emphasized color="$black">{title}</H6Emphasized>
                            <YStack gap={4}>
                                <BodySmallRegular color="$black">
                                    {metric.label}
                                </BodySmallRegular>
                                <H6Regular color="$black">
                                    {metric.value}
                                </H6Regular>
                            </YStack>
                        </YStack>
                    </XStack>
                </YStack>
            </YStack>
        </FrostedSurface>
    );
};
